import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLessMoneyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M13.25 12C13 12.75 12.3399 13.25 11.5 13.25C10 13.25 9.25 11.5 9.25 9.5C9.25 7.5 10 5.75 11.5 5.75C12.3399 5.75 13 6.25 13.25 7M8.25 8.25H10.75M8.25 10.75H10.75" }), /* @__PURE__ */ _jsx("path", { d: "M2.5 2.5L6.25 6.25M6.25 6.25V3.25M6.25 6.25H3.25" })]
});
export default SvgLessMoneyIcon;
